import { SmartTable } from '../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
        this.st = new SmartTable();
        this.allItems = [...this.companyUsers, ...this.hardTokens]
            .filter(({companyUserId}) => !companyUserId);
            console.log(this.companyUsers);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/all-users/all-users.controller.js